module.exports = __webpack_public_path__ + "static/img/77092G_R_01_20170922all_fit.a542d5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/77092G_R_01_20170922all_fit.png
// module id = 6lcH
// module chunks = 0